import isDev from './isDev';
import getEnvValue from './getEnvValue';

const isCaptchaEnabled = !isDev && getEnvValue('VITE_PROJECT_ENV') !== 'stage';

export default isCaptchaEnabled;
